// Single-session payload — stores the full `/guardian-users/me` response
// (user profile + Branches array) plus the user's currently-selected branch
// so it survives reloads / re-logins.

import {
  USER_DETAILS_STORAGE_KEY,
  SELECTED_BRANCH_STORAGE_KEY,
  SELECTED_BRANCH_META_STORAGE_KEY,
  GLOBAL_SETTINGS_CACHE_STORAGE_KEY,
} from './constants'

export const userStorage = {
  getUserDetails: () => {
    const raw = localStorage.getItem(USER_DETAILS_STORAGE_KEY)
    if (!raw) return null
    try {
      return JSON.parse(raw)
    } catch {
      return null
    }
  },
  setUserDetails: (details) => {
    if (!details) {
      localStorage.removeItem(USER_DETAILS_STORAGE_KEY)
      return
    }
    localStorage.setItem(USER_DETAILS_STORAGE_KEY, JSON.stringify(details))
  },
  clearUserDetails: () => localStorage.removeItem(USER_DETAILS_STORAGE_KEY),

  getSelectedBranch: () => {
    const raw = localStorage.getItem(SELECTED_BRANCH_STORAGE_KEY)
    if (!raw) return null
    try {
      return JSON.parse(raw)
    } catch {
      return null
    }
  },
  setSelectedBranch: (branch) => {
    if (!branch) {
      localStorage.removeItem(SELECTED_BRANCH_STORAGE_KEY)
      localStorage.removeItem(SELECTED_BRANCH_META_STORAGE_KEY)
      return
    }
    localStorage.setItem(SELECTED_BRANCH_STORAGE_KEY, JSON.stringify(branch))
    // Mirror a stripped-down summary so consumers that only need uuid / id /
    // name don't have to JSON.parse the full payload.
    const meta = {
      uuid: branch.uuid || null,
      id: branch.id ?? null,
      name: branch.name || null,
    }
    localStorage.setItem(SELECTED_BRANCH_META_STORAGE_KEY, JSON.stringify(meta))
  },
  clearSelectedBranch: () => {
    localStorage.removeItem(SELECTED_BRANCH_STORAGE_KEY)
    localStorage.removeItem(SELECTED_BRANCH_META_STORAGE_KEY)
  },
  clearAllUserData: () => {
    localStorage.removeItem(SELECTED_BRANCH_STORAGE_KEY)
    localStorage.removeItem(SELECTED_BRANCH_META_STORAGE_KEY)
    localStorage.removeItem(USER_DETAILS_STORAGE_KEY)
    localStorage.removeItem(GLOBAL_SETTINGS_CACHE_STORAGE_KEY)
  },

  getSelectedBranchMeta: () => {
    const raw = localStorage.getItem(SELECTED_BRANCH_META_STORAGE_KEY)
    if (!raw) return null
    try {
      return JSON.parse(raw)
    } catch {
      return null
    }
  },
}

// Standalone helper for code paths that don't sit inside a component
// (e.g. axios interceptors, mutation callbacks). Same as
// `userStorage.getSelectedBranchMeta()`.
export const getSelectedBranchMeta = () => {
  const raw = localStorage.getItem(SELECTED_BRANCH_META_STORAGE_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}
